import _classPrivateFieldLooseBase from "@babel/runtime/helpers/esm/classPrivateFieldLooseBase";
import _classPrivateFieldLooseKey from "@babel/runtime/helpers/esm/classPrivateFieldLooseKey";
export let States;
(function (States) {
  States["NOT_REQUESTED"] = "NOT_REQUESTED";
  States["REQUESTED"] = "REQUESTED";
  States["SUCCEEDED"] = "SUCCEEDED";
  States["FAILED"] = "FAILED";
})(States || (States = {}));
var _state = /*#__PURE__*/_classPrivateFieldLooseKey("state");
var _message = /*#__PURE__*/_classPrivateFieldLooseKey("message");
var _error = /*#__PURE__*/_classPrivateFieldLooseKey("error");
// Represents the state of of API request.
// Each request can have multiple possible states, so one boolean on its own
// isn't enough to track its state. This "enum" works better.
//
// Use RequestStates.REQUESTED, RequestStates.SUCCEEDED, etc, from the exports.
// Use PropTypes.instanceOf(RequestState) to type-check within components.
// Make use of the `should*` methods when using inside of components & actions.
export default class RequestState {
  constructor(args) {
    Object.defineProperty(this, _state, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _message, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _error, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldLooseBase(this, _state)[_state] = args.state || States.NOT_REQUESTED;
    _classPrivateFieldLooseBase(this, _message)[_message] = args.message || null;
    _classPrivateFieldLooseBase(this, _error)[_error] = args.error || null;
  }
  isNotRequested() {
    return _classPrivateFieldLooseBase(this, _state)[_state] === States.NOT_REQUESTED;
  }
  isPending() {
    return _classPrivateFieldLooseBase(this, _state)[_state] === States.REQUESTED;
  }
  isSuccessful() {
    return _classPrivateFieldLooseBase(this, _state)[_state] === States.SUCCEEDED;
  }
  isFailed() {
    return _classPrivateFieldLooseBase(this, _state)[_state] === States.FAILED;
  }
  isComplete() {
    return this.isSuccessful() || this.isFailed();
  }
  shouldBeRequested() {
    return this.isNotRequested() || this.isFailed();
  }
  shouldShowAsLoading() {
    return this.isNotRequested() || this.isPending();
  }
  hasMessage() {
    return this.getMessage() !== null;
  }
  setMessage(value) {
    return _classPrivateFieldLooseBase(this, _message)[_message] = value;
  }
  getMessage() {
    return _classPrivateFieldLooseBase(this, _message)[_message];
  }
  setError(error) {
    return _classPrivateFieldLooseBase(this, _error)[_error] = error;
  }
  getError() {
    return _classPrivateFieldLooseBase(this, _error)[_error];
  }
  isErrorCode(code) {
    return (this.getError() || {}).status === code;
  }
  is403() {
    return this.isErrorCode(403);
  }
}
export const NOT_REQUESTED = new RequestState({
  state: States.NOT_REQUESTED
});
export const REQUESTED = new RequestState({
  state: States.REQUESTED
});
export const SUCCEEDED = new RequestState({
  state: States.SUCCEEDED
});
export const FAILED = new RequestState({
  state: States.FAILED
});